module.exports = __webpack_public_path__ + "img/Anatomic-crown.1896b70a.jpg";